<template>
  <div>
    <b-modal :id="modalName" size="lg" hide-footer
             title="Paramètres de profil">
      <b-form @submit="onSubmit">
        <b-row>
          <b-col>
            <div class="hide">
              {{profil}}
            </div>

            <blinki-input-txt v-model="LocalProfil.nom"
                              id="nom"
                              label="nom"
                              placeholder="Nom ."
                              module="profil"></blinki-input-txt>
            <blinki-input-txt v-model="LocalProfil.prenom"
                              id="prenom"
                              label="prénom"
                              placeholder="Prénom..."
                              module="profil"></blinki-input-txt>
            <blinki-input-txt v-model="LocalProfil.telephone"
                              id="phone"
                              :is_phone="true"
                              :optionnel="true"
                              label="Téléphone"
                              :state="isPhone"
                              module="profil"></blinki-input-txt>
          </b-col>
          <b-col>
            <blinki-input-txt v-model="LocalProfil.email"
                              id="email"
                              type="email"
                              :show_error="!isMailValid"
                              label="E-mail"
                              placeholder="E-mail"
                              module="profil"></blinki-input-txt>
            <blinki-input-txt v-model="LocalProfil.password"
                              id="password"
                              type="password"
                              label="Mot de passe"
                              module="profil"></blinki-input-txt>
            <blinki-input-txt v-model="confirm_password"
                              id="confirm_password"
                              type="password"
                              label="confirmer mot de passe"
                              module="profil"></blinki-input-txt>
          </b-col>
        </b-row>
        <save-btn-container :modal_name="modalName" :valid="isFormValid"></save-btn-container>
      </b-form>
    </b-modal>
  </div>
</template>
<script>
  import blinkiInputTxt from '~/components/template/form/blinki-input-txt';
  import saveBtnContainer from '~/components/popups/save-btn-container';
  export default {
    components: {
      saveBtnContainer,
      blinkiInputTxt
    },
    data() {
      return {
        modalName: 'profil-update',
        confirm_password:'',
        isPhone:false,
        LocalProfil:{},
        isFormValid:false
      }
    },
    props:[],
    mounted() {
    },
    computed: {
      profil:{
        get(){
          const object = Object.assign({}, this.$store.getters['auth/getProfil']);
          this.LocalProfil = object;
          return object;
        },
        set(value){
          this.LocalProfil = value
        }
      },
      isMailValid(){
        return this.$validMail(this.LocalProfil.email)
      },
    },
    watch:{
      LocalProfil:{
        handler: function(val, oldVal) {
          this.validate()
        },
        deep: true
      },
      confirm_password:{
        handler: function(val, oldVal) {
          this.validate()
        },
        deep: true
      }
    },
    methods: {
      validate(){
        this.isPhone = this.$isPhone(this.LocalProfil.telephone);
        this.isFormValid = (this.LocalProfil.password ? this.LocalProfil.password === this.confirm_password : true) && this.isPhone
      },
      onSubmit(evt) {
        evt.preventDefault();
        this.$store.dispatch('auth/update', {...this.profil});
        this.$bvModal.hide(this.modalName)
      }
    },
  }
</script>

<style scoped>
  .hide{
    display: none;
  }
</style>
